import React, { useEffect, useState, createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
type UserRole = 'admin' | 'dealer' | null;
interface AuthContextType {
  isAuthenticated: boolean;
  userRole: UserRole;
  login: (username: string, password: string, role: UserRole) => Promise<boolean>;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState<UserRole>(null);
  const navigate = useNavigate();
  // Check if user is already logged in on component mount
  useEffect(() => {
    const savedAuth = localStorage.getItem('auth');
    if (savedAuth) {
      const {
        isAuthenticated,
        userRole
      } = JSON.parse(savedAuth);
      setIsAuthenticated(isAuthenticated);
      setUserRole(userRole);
    }
  }, []);
  const login = async (username: string, password: string, role: UserRole): Promise<boolean> => {
    // In a real app, this would make an API call to authenticate
    // For demo purposes, we'll accept any credentials
    // Mock admin credentials check
    if (role === 'admin' && username === 'admin' && password === 'admin123') {
      setIsAuthenticated(true);
      setUserRole('admin');
      // Save auth state to localStorage
      localStorage.setItem('auth', JSON.stringify({
        isAuthenticated: true,
        userRole: 'admin'
      }));
      return true;
    }
    // Mock dealer credentials check
    if (role === 'dealer' && username === 'dealer' && password === 'dealer123') {
      setIsAuthenticated(true);
      setUserRole('dealer');
      // Save auth state to localStorage
      localStorage.setItem('auth', JSON.stringify({
        isAuthenticated: true,
        userRole: 'dealer'
      }));
      return true;
    }
    return false;
  };
  const logout = () => {
    setIsAuthenticated(false);
    setUserRole(null);
    localStorage.removeItem('auth');
    navigate('/login');
  };
  return <AuthContext.Provider value={{
    isAuthenticated,
    userRole,
    login,
    logout
  }} data-id="element-1388">
      {children}
    </AuthContext.Provider>;
};
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};